import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LookupPipe } from './pipes/lookup.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    LookupPipe
  ],
  declarations: [
    LookupPipe
  ],
  providers: [
    LookupPipe
  ]
})
export class StpFormsModule { }
